import { render, staticRenderFns } from "./rDetail.vue?vue&type=template&id=32ec84a8"
import script from "./rDetail.vue?vue&type=script&lang=js"
export * from "./rDetail.vue?vue&type=script&lang=js"
import style0 from "./rDetail.vue?vue&type=style&index=0&id=32ec84a8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports